<app-side-dialog class="min-w-[480px]" [disableClose]="true" (closeDialog)="onBackClick()">
  <div dialogHeader>
    <h2>{{ 'dialogs.createCampaignDialog.briefWizard.warningsDialog.title' | translate }}</h2>
  </div>

  <div dialogContent class="flex flex-col gap-4">
    <p>{{ 'dialogs.createCampaignDialog.briefWizard.warningsDialog.message' | translate }}</p>

    <ul class="flex flex-col gap-2 list-disc pl-5">
      @for (warning of data.warnings; track warning.code + warning.path) {
        <li>
          @if (getWarningTemplateName(warning); as templateName) {
            <span class="font-bold">{{ templateName }}: </span>
          }
          {{ getWarningMessage(warning) }}
        </li>
      }
    </ul>

    <div class="flex justify-end gap-3 mt-2">
      <button mat-flat-button color="secondary-transparent" type="button" (click)="onBackClick()">
        {{ 'dialogs.createCampaignDialog.briefWizard.warningsDialog.back' | translate }}
      </button>

      <button mat-flat-button type="button" (click)="onContinueClick()">
        {{ 'dialogs.createCampaignDialog.briefWizard.warningsDialog.continue' | translate }}
      </button>
    </div>
  </div>
</app-side-dialog>
